export function Cache(storage) {
  Cache.prototype.storage = storage;
}

Cache.prototype.get = function (k) {
  let v = this.storage.getItem(k);
  return JSON.parse(v)
};
Cache.prototype.set = function (k, v) {
    return this.storage.setItem(k, JSON.stringify(v));
};
Cache.prototype.clear = function () {
  return this.storage.clear();
};
Cache.prototype.remove = function (k) {
  return this.storage.removeItem(k);
};
